var _excluded = ["text"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { useRef } from 'react';
import classnames from 'classnames';
import { Text } from "../../Text/Text/Text";
import { Button } from "../../Button/Button/Button";
import Utility from "../../Utility/Utility";
import styles from "./RadioInput.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var RadioInput = function RadioInput(_ref) {
  var _ref$border = _ref.border,
    border = _ref$border === void 0 ? false : _ref$border,
    _ref$circleClass = _ref.circleClass,
    circleClass = _ref$circleClass === void 0 ? '' : _ref$circleClass,
    cta = _ref.cta,
    _ref$enable = _ref.enable,
    enable = _ref$enable === void 0 ? true : _ref$enable,
    _ref$flag = _ref.flag,
    flag = _ref$flag === void 0 ? '' : _ref$flag,
    _ref$flagWrapperClass = _ref.flagWrapperClass,
    flagWrapperClass = _ref$flagWrapperClass === void 0 ? '' : _ref$flagWrapperClass,
    _ref$flagClass = _ref.flagClass,
    flagClass = _ref$flagClass === void 0 ? '' : _ref$flagClass,
    _ref$flagTypog = _ref.flagTypog,
    flagTypog = _ref$flagTypog === void 0 ? 'subhead4' : _ref$flagTypog,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    _ref$labelClass = _ref.labelClass,
    labelClass = _ref$labelClass === void 0 ? '' : _ref$labelClass,
    _ref$labelTypog = _ref.labelTypog,
    labelTypog = _ref$labelTypog === void 0 ? 'caption' : _ref$labelTypog,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? null : _ref$description,
    _ref$descriptionHidde = _ref.descriptionHidden,
    descriptionHidden = _ref$descriptionHidde === void 0 ? null : _ref$descriptionHidde,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? '' : _ref$name,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _ref$valueSelected = _ref.valueSelected,
    valueSelected = _ref$valueSelected === void 0 ? '' : _ref$valueSelected,
    _ref$version = _ref.version,
    version = _ref$version === void 0 ? 'default' : _ref$version,
    _ref$wrapperClass = _ref.wrapperClass,
    wrapperClass = _ref$wrapperClass === void 0 ? '' : _ref$wrapperClass,
    _ref$mobileCarousel = _ref.mobileCarousel,
    mobileCarousel = _ref$mobileCarousel === void 0 ? false : _ref$mobileCarousel,
    simplifiedCards = _ref.simplifiedCards;
  var id = useRef(Utility.generateUID(name)).current;
  var change = function change() {
    if (enable) {
      onChange(value);
    }
  };
  var renderCTA = function renderCTA() {
    var _ref2 = cta || {},
      text = _ref2.text,
      otherProps = _objectWithoutProperties(_ref2, _excluded);
    var button = function button() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'primary';
      return text && /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
        className: classnames(styles.innerExpandedCTA, {
          [styles.pointerEvent]: version === 'V3'
        }),
        type: type
      }, otherProps), {}, {
        children: text
      }));
    };
    switch (version) {
      case 'V3':
        return flag ? button() : button('secondary');
      case 'V2':
        return value === valueSelected ? button() : null;
      default:
        return null;
    }
  };
  if (simplifiedCards) {
    return /*#__PURE__*/_jsx("div", {
      className: classnames(styles.wrapper, wrapperClass, styles.borderV6, {
        [styles.selectedV6]: border && value === valueSelected
      }),
      children: /*#__PURE__*/_jsxs("label", {
        className: classnames(styles.label, {
          [styles.disabled]: !enable
        }),
        htmlFor: id,
        children: [flag && border && /*#__PURE__*/_jsx("div", {
          className: classnames(styles.flagV6, flagWrapperClass),
          children: /*#__PURE__*/_jsx(Text, {
            typog: flagTypog || 'caption',
            className: classnames(styles.flagText, flagClass),
            children: Utility.dangerousHTML(flag)
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: classnames(styles.topV6, {
            [styles.withCarousel]: mobileCarousel
          }),
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.container,
            children: [/*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx("input", {
                className: classnames(styles.input, !enable && styles.disabled),
                onChange: change,
                id: id,
                name: name,
                type: "radio",
                value: value,
                checked: value === valueSelected
              })
            }), /*#__PURE__*/_jsx(Text, {
              typog: 'headline4',
              className: classnames(styles.textV6, styles.text, labelClass),
              children: label
            })]
          }), description]
        })]
      })
    });
  } else {
    return /*#__PURE__*/_jsx("div", {
      className: classnames(styles.wrapper, wrapperClass, {
        [styles.border]: border,
        [styles.selected]: border && value === valueSelected && version !== 'V3',
        [styles.expanded]: version !== 'default',
        [styles.borderV4]: version === 'V4'
      }),
      children: /*#__PURE__*/_jsxs("label", {
        className: classnames(styles.label, {
          [styles.disabled]: !enable
        }),
        htmlFor: id,
        children: [flag && border && /*#__PURE__*/_jsx("div", {
          className: classnames(styles.flag, flagWrapperClass),
          children: /*#__PURE__*/_jsx(Text, {
            typog: flagTypog || 'caption',
            className: classnames(styles.flagText, flagClass),
            children: Utility.dangerousHTML(flag)
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: version === 'V4' ? styles.topV4 : styles.top,
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.container,
            children: [/*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("input", {
                className: classnames(styles.input, !enable && styles.disabled),
                onChange: change,
                id: id,
                name: name,
                type: "radio",
                value: value,
                checked: value === valueSelected,
                disabled: version === 'V3'
              }), /*#__PURE__*/_jsx("span", {
                className: classnames(styles.circle, circleClass, {
                  [styles.hiddenRadio]: version === 'V3' || version === 'V4'
                })
              })]
            }), /*#__PURE__*/_jsx(Text, {
              typog: version === 'V4' ? 'headline4' : labelTypog || 'caption',
              className: classnames(styles.text, {
                [styles.textV4]: version === 'V4'
              }, labelClass),
              children: label
            })]
          }), description]
        }), descriptionHidden && /*#__PURE__*/_jsxs("div", {
          className: classnames({
            [styles.descriptionHidden]: (version === 'default' || version === 'V4') && !mobileCarousel,
            [styles.descriptionExpanded]: version !== 'default' || mobileCarousel
          }),
          children: [descriptionHidden, /*#__PURE__*/_jsx("div", {
            className: styles.expandedBoxCTA,
            children: renderCTA()
          })]
        })]
      })
    });
  }
};